import { Pipe, PipeTransform } from '@angular/core';
import { isAfter, subMonths } from 'date-fns';

@Pipe({
  name: 'expires',
})
export class ExpiresPipe implements PipeTransform {
  transform(value?: Date | null): boolean {
    if (!value) {
      return false;
    }

    return isAfter(new Date(), subMonths(value, 3));
  }
}
